import env from '../env';

export default {
	MARKETING_MATERIALS: `${env.API_VIEWER}InventoryView/GetPostsByCatalogID`,
};
